import { Chartisan, ChartisanHooks } from '@chartisan/chartjs';
import route from 'ziggy-js';
import axios from 'axios';
import waitUntil from './Support/waitUntil';

const isPublicReport = Array.from(document.querySelectorAll('#chartisan')).some((el) => el.dataset.public === '1');

const convertChartToImage = async (chart) => {
  const url = new URL(`https://insights.co.uk${chart.options.url}`);
  const reportId = url.searchParams.get('report_id');
  const type = url.searchParams.get('type');

  axios({
    method: 'post',
    url: route('internal-api.chart-images.store', { report: reportId }),
    data: {
      image: chart.toImage(),
      type,
    },
  });
};

const convertChart = async (chart) => {
  await waitUntil(() => chart.cstate === 'show', 1000);
  await convertChartToImage(chart);
};

document.querySelectorAll('#chartisan').forEach(async (element) => {
  const chart = new Chartisan({
    el: `#${element.dataset.chartId}`,
    url: `${element.dataset.chartUrl}`.replace(/&amp;/g, '&'),
    hooks: new ChartisanHooks()
      .borderColors([
        '#A6CEE3',
        '#1F78B4',
        '#B2DF8A',
        '#33A02C',
        '#F67280',
      ])
      .responsive()
      .animation({
        duration: 0,
      })
      .legend({ position: 'bottom' })
      .datasets([{ type: 'line', fill: false }])
      .tooltip({
        enabled: true,
        mode: 'single',
        callbacks: {
          label(tooltipItems) {
            const formatter = Intl.NumberFormat('en', {
              notation: 'compact',
            });
            return `£${formatter.format(tooltipItems.yLabel)}`;
          },
        },
      })
      .custom(({ data, merge }) => {
        const axesColor = element.dataset.axesColor || '#6b7280';

        return merge(data, {
          options: {
            legend: {
              labels: {
                fontColor: axesColor,
              },
            },
            scales: {
              yAxes: [
                {
                  min: `${element.dataset.minPrice}`,
                  ticks: {
                    fontColor: axesColor,
                    stepSize: 50000,
                    callback(value) {
                      const formatter = Intl.NumberFormat('en', {
                        notation: 'compact',
                      });
                      return (
                        `£${
                          formatter.format(value)}`
                      );
                    },
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    fontColor: axesColor,
                  },
                },
              ],
            },
          },
        });
      }),
  });

  if (!isPublicReport) {
    await convertChart(chart);
  }

  return chart;
});
